
import VueMultiSelect from 'vue-multiselect'
import debounce from '@/mixins/debounce'
import isObject from 'lodash/isObject'

export default {
    components: { VueMultiSelect },

    props: {
        value: {
            type: [Array, Object, String, Number],
            default: undefined,
        },
        options: {
            type: Array,
            default: () => [],
        },
        api: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: 'Select',
        },
        caretIcon: {
            type: String,
            default: 'chevron-right',
        },
        family: {
            type: String,
            default: 'far',
        },
        contentAlign: {
            type: String,
            default: undefined,
            validator: (value) => ['right'].includes(value),
        },
        searchParams: {
            type: Object,
            default: () => {},
        },
        trackBy: String,
        label: String,
        allowEmpty: Boolean,
        searchable: Boolean,
        multiple: Boolean,
        taggable: Boolean,
        pill: Boolean,
        disabled: Boolean,
        hidden: Boolean,
        flat: Boolean,
        required: Boolean,
        block: Boolean,
        xl: Boolean,
        lg: Boolean,
        sm: Boolean,
        xs: Boolean,
    },

    data() {
        return {
            searchOptions: [],
        }
    },

    computed: {
        hasClear() {
            return this.$listeners && this.$listeners.clear
        },

        computedOptions() {
            return (this.api ? this.searchOptions : this.options) || []
        },

        flatError() {
            return this.flat && (!this.trackBy || !this.label)
        },

        innerValue() {
            if (this.flat && !this.flatError)
                return this.multiple
                    ? this.computedOptions.filter((option) => this.value.includes(option[this.trackBy]))
                    : this.computedOptions.find((option) => option[this.trackBy] === this.value)
            return this.value
        },
    },

    mounted() {
        if (this.api) this.getOptions()
        if (this.flatError)
            // eslint disable no-console
            console.error('Please provide the tracbBy and label property for the flat feature to work!')
    },

    methods: {
        getList: debounce(function (search) {
            this.getOptions(search)
        }, 500),

       async  getOptions(search) {
            try {
                const result = await this.$axios.$get(`${this.api}${search ? `${this.api.includes('?') ? '&' : '?'}q=${search}&name=${search}` : ''}`, this.searchParams)
                this.$emit('update:search', search)
                this.searchOptions = result.data
            } catch {
                this.searchOptions = []
            }
        },
        onInput($event) {
            if (this.flat && !this.flatError)
                if (this.multiple)
                    this.$emit(
                        'input',
                        $event.map((el) => el[this.trackBy])
                    )
                else this.$emit('input', $event[this.trackBy])
            else this.$emit('input', $event)
        },
        onClear(e) {
            e.stopPropagation()
            e.preventDefault()
            if (this.hasClear) this.$emit('clear')
            else this.$emit('input', undefined)
        },
        toggle(){
            this.$refs.multiselect.toggle()
        },
    },
}
